module.exports = __webpack_public_path__ + "static/img/20220610_02.e626d5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20220610_02.png
// module id = ihRC
// module chunks = 0